import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import ProjectCardGrid from "./subcomponents/ProjectCardGrid";

export const Projects = () => {
	return (
		<motion.div
			className="vih"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
		>
			<Container id="widthRes" className="p-5">
				<motion.h1
					initial={{ border: 0, opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5 }}
					className=" text-light text-center m-auto p-3 mt-4 mb-5 border-bottom border-top  rounded"
				>
					Projects
				</motion.h1>
				<ProjectCardGrid />
				{/* <div className="d-flex flex-column mt-5">
					<div className="m-auto text-white subfont">
						More projects in progress, check here again.
					</div>
					<div id="wave">
						<span class="dot"></span>
						<span class="dot"></span>
						<span class="dot"></span>
					</div>
				</div> */}
			</Container>
		</motion.div>
	);
};
